import { Link } from "react-router-dom";
import MarketplaceHeader from "../components/MarketplaceHeader";
import FloatingTools from "../components/FloatingTools";
import Footer from "../components/Footer";

const solutions = [
  { title: "Seller storefront", body: "Register, verify your store, list products and manage buyer enquiries.", to: "/register?type=SELLER", tag: "Sellers" },
  { title: "Business operations", body: "For supermarkets and larger shops with branches, suppliers, stock movement and catalogue scale.", to: "/register?type=BUSINESS", tag: "Business" },
  { title: "Transporter services", body: "Create courier services, publish routes and receive delivery jobs.", to: "/register?type=COURIER", tag: "Logistics" },
  { title: "Source request", body: "Buyers can request what they need and get routed to suitable sellers.", to: "/request", tag: "Buyers" },
];

const operations = [
  "Verified seller onboarding",
  "Product catalogue and availability",
  "Business branches and suppliers",
  "Goods movement and inventory activity",
  "Transporter service selection",
  "TAZY payments, commissions and subscriptions",
];

export default function BusinessSolutions() {
  return (
    <div className="page-shell marketplace-page business-solutions-page" id="top">
      <MarketplaceHeader apiOnline />
      <main className="container public-directory-shell">
        <section className="marketplace-title-banner marketplace-title-banner--business">
          <img src="/images/tazy-marketplace-banner.png" alt="" />
          <div className="marketplace-title-banner__content">
            <span>BUSINESS SOLUTIONS</span>
            <h1>Marketplace tools for sellers, shops and logistics partners.</h1>
            <p>TAZY CART connects selling, sourcing, business operations, transport services and finance workflows in one marketplace engine.</p>
            <div className="hero-action-row hero-action-row--inline">
              <Link to="/register?type=BUSINESS">Open business account</Link>
              <Link to="/register?type=SELLER">Start selling</Link>
              <Link to="/transporters">View transporters</Link>
            </div>
          </div>
        </section>

        <section className="solutions-grid solutions-grid-v2">
          {solutions.map((solution) => (
            <Link key={solution.title} to={solution.to}>
              <span>{solution.tag}</span>
              <strong>{solution.title}</strong>
              <p>{solution.body}</p>
              <b>Open ›</b>
            </Link>
          ))}
        </section>

        <section className="business-operations-board">
          <div>
            <span>Operational backbone</span>
            <h2>Built beyond ordinary e-commerce.</h2>
            <p>Business accounts can move toward branch-level stock control, supplier records, goods movement, subscription access and order fulfilment with transporters.</p>
          </div>
          <div className="business-operations-list">
            {operations.map((item) => <div key={item}><span>✓</span>{item}</div>)}
          </div>
        </section>
      </main>
      <Footer />
      <FloatingTools />
    </div>
  );
}
